<template>
  <span v-if="multi" :class="`icon-${name}`">
    <span v-for="i in 10" :key="i" :class="`path${i}`" />
  </span>

  <span v-else :class="`icon icon-${name}`" />
</template>

<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true
    },
    multi: { type: Boolean }
  }
};
</script>
